import cobhamCoatWallet from '../../assets/img/cobham_coat_wallet.png';
import alligatorStrapBrown from '../../assets/img/alligator_strap_brown.png';
import alligatorStrapBlack from '../../assets/img/alligator_strap_black.png';
import canvasStrapGreen from '../../assets/img/canvas_strap_green.png';
import leatherStrapBlackWhite from '../../assets/img/leather_strap_black_white.png';
import mbBarrelBronze from '../../assets/img/mb_barrel_bronze.png';
import pinBuckleSteel from '../../assets/img/pin_buckle_steel.png';
import pinBuckleSteelPolished from '../../assets/img/pin_buckle_steel_polished.png';
import pinBuckleTitanium from '../../assets/img/pin_buckle_titanium.png';
import pinBuckleDlc from '../../assets/img/pin_buckle_dlc.png';
import natoStrapKhaki from '../../assets/img/nato_strap_khaki.png';
import natoStrapBlackRed from '../../assets/img/nato_strap_black_red.png';
import natoStrapBlackWhite from '../../assets/img/nato_strap_black_white.png';
import hipFlask from '../../assets/img/hip_flask.png';
import bremontInvictusBracelet from '../../assets/img/bremont_invictus_bracelet.png';
import natoStrapGreyCanvas from '../../assets/img/nato_strap_grey_canvas.png';
import natoStrapStoneCanvas from '../../assets/img/nato_strap_stone_canvas.png';
import nubuckLadiesStrapBlack from '../../assets/img/nubuck_ladies_strap_black.png';
import lizardLadiesStrapWhite from '../../assets/img/lizard_ladies_strap_white.png';
import leatherLadiesStrapTan from '../../assets/img/leather_ladies_strap_tan.png';
import crocodileLadiesStrapDarkRed from '../../assets/img/crocodile_ladies_strap_dark_red.png';
import alligatorLadiesStrapDarkBlue from '../../assets/img/alligator_ladies_strap_dark_blue.png';
import alligatorLadiesStrapBlack from '../../assets/img/alligator_ladies_strap_black.png';
import leatherStrapBlackRedNortonV4 from '../../assets/img/leather_strap_black_red_norton_v4.png';
import vintageLeatherStrapDarkBrownFullStitch from '../../assets/img/vintage_leather_strap_dark_brown_full_stitch.png';
import vintageLeatherStrapDarkBrownSideStitch from '../../assets/img/vintage_leather_strap_dark_brown_side_stitch.png';
import pocketSquareRed from '../../assets/img/pocket_square_red.png';
import pocketSquareGreen from '../../assets/img/pocket_square_green.png';
import tieGreen from '../../assets/img/tie_green.png';
import tieRed from '../../assets/img/tie_red.png';

export default [
    {
        "id": 2204678213,
        "title": "Cobham Coat Wallet",
        "handle": "cobham-coat-wallet",
        "body_html": "<p>Bremont’s Cobham Coat Wallet includes eight credit card compartments, two full length pockets for ample note storage and two large sections to stow additional documents. The wallet features blind Bremont logo and propeller embossing and is crafted from deluxe calf and English bridle leather, guaranteeing excellent quality.</p>\n<p>Made in England, the Cobham Coat Wallet approximately measures a width of 10.7cm by 18.3cm height, sizes may vary marginally.</p>\n<p>See how this product is made in our film below.</p>\n<iframe width=\"500\" height=\"300\" src=\"https://www.youtube.com/embed/3qIV8zRGJ0s?rel=0&amp;showinfo=0\" frameborder=\"0\" allowfullscreen=\"\"></iframe>",
        "published_at": "2017-11-29T14:21:51+00:00",
        "created_at": "2015-09-23T11:59:18+01:00",
        "updated_at": "2017-12-12T14:27:55+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Accessories",
        "tags": [
            "for-the-adventurer",
            "for-the-gentleman",
            "for-the-lady",
            "for-the-mariner",
            "leather-accessories",
            "over-150"
        ],
        "variants": [
            {
                "id": 6332349189,
                "title": "Black",
                "option1": "Black",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5037",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "165.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2204678213,
                "created_at": "2015-09-23T11:59:18+01:00",
                "updated_at": "2017-12-12T14:27:55+00:00"
            }
        ],
        "images": [
            {
                "id": 4215467909,
                "created_at": "2015-09-23T12:00:08+01:00",
                "position": 1,
                "updated_at": "2015-09-23T12:00:08+01:00",
                "product_id": 2204678213,
                "variant_ids": [],
                "src": cobhamCoatWallet,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 4215467973,
                "created_at": "2015-09-23T12:00:09+01:00",
                "position": 2,
                "updated_at": "2015-09-23T12:00:09+01:00",
                "product_id": 2204678213,
                "variant_ids": [],
                "src": cobhamCoatWallet,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 4215468933,
                "created_at": "2015-09-23T12:00:21+01:00",
                "position": 3,
                "updated_at": "2015-09-23T12:00:21+01:00",
                "product_id": 2204678213,
                "variant_ids": [],
                "src": cobhamCoatWallet,
                "width": 1024,
                "height": 683
            }
        ],
        "options": [
            {
                "name": "Color",
                "position": 1,
                "values": [
                    "Black"
                ]
            }
        ]
    },
    {
        "id": 2204590853,
        "title": "Alligator Strap - Wright Flyer Brown",
        "handle": "wright-flyer-alligator-strap-brown",
        "body_html": "<meta charset=\"utf-8\">\n<p>Brown genuine alligator leather Wright Flyer strap with white stitching and embossed Wright Brothers Family Foundation logo.</p>\n<p>Lightly cushioned with a taper profile.</p>\n<p>Available to customers in the United Kingdom only.</p>\n<meta charset=\"utf-8\">\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-11-22T15:13:54+00:00",
        "created_at": "2015-09-23T11:27:14+01:00",
        "updated_at": "2017-11-28T19:41:25+00:00",
        "vendor": "Bremont",
        "product_type": "Alligator Straps",
        "tags": [
            "alligator",
            "alligator-straps",
            "brown",
            "for-the-gentleman",
            "length-extra-long",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 6331936453,
                "title": "22mm / Regular",
                "option1": "22mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.163.2074",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2204590853,
                "created_at": "2015-09-23T11:27:14+01:00",
                "updated_at": "2017-11-28T19:41:25+00:00"
            },
            {
                "id": 6331936389,
                "title": "22mm / Short",
                "option1": "22mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.163.2075",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 2204590853,
                "created_at": "2015-09-23T11:27:14+01:00",
                "updated_at": "2017-11-20T11:28:00+00:00"
            },
            {
                "id": 6331936517,
                "title": "22mm / Long",
                "option1": "22mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.163.2076",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 2204590853,
                "created_at": "2015-09-23T11:27:14+01:00",
                "updated_at": "2017-11-12T23:29:18+00:00"
            },
            {
                "id": 6331936581,
                "title": "22mm / Extra Long",
                "option1": "22mm",
                "option2": "Extra Long",
                "option3": null,
                "sku": "BR.163.2077",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 4,
                "product_id": 2204590853,
                "created_at": "2015-09-23T11:27:14+01:00",
                "updated_at": "2017-11-20T11:29:18+00:00"
            }
        ],
        "images": [
            {
                "id": 4215255237,
                "created_at": "2015-09-23T11:27:47+01:00",
                "position": 1,
                "updated_at": "2015-09-23T11:27:47+01:00",
                "product_id": 2204590853,
                "variant_ids": [],
                "src": alligatorStrapBrown,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 4215255557,
                "created_at": "2015-09-23T11:27:49+01:00",
                "position": 2,
                "updated_at": "2015-09-23T11:27:49+01:00",
                "product_id": 2204590853,
                "variant_ids": [],
                "src": alligatorStrapBrown,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long",
                    "Extra Long"
                ]
            }
        ]
    },
    {
        "id": 2204573637,
        "title": "Alligator Strap - Wright Flyer Black",
        "handle": "wright-flyer-alligator-strap-black",
        "body_html": "<meta charset=\"utf-8\">\n<p>Black genuine alligator leather Wright Flyer strap with black stitching and embossed Wright Brothers Family Foundation logo.</p>\n<p>Lightly cushioned with a taper profile.</p>\n<p>Available to customers in the United Kingdom only.</p>\n<meta charset=\"utf-8\">\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-11-22T15:13:54+00:00",
        "created_at": "2015-09-23T11:23:46+01:00",
        "updated_at": "2017-11-23T12:04:00+00:00",
        "vendor": "Bremont",
        "product_type": "Alligator Straps",
        "tags": [
            "alligator",
            "alligator-straps",
            "black",
            "for-the-gentleman",
            "length-extra-long",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 6331857733,
                "title": "22mm / Regular",
                "option1": "22mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.163.2070",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2204573637,
                "created_at": "2015-09-23T11:23:46+01:00",
                "updated_at": "2017-11-12T23:29:18+00:00"
            },
            {
                "id": 6331857669,
                "title": "22mm / Short",
                "option1": "22mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.163.2071",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 2204573637,
                "created_at": "2015-09-23T11:23:46+01:00",
                "updated_at": "2017-11-12T23:29:18+00:00"
            },
            {
                "id": 6331857797,
                "title": "22mm / Long",
                "option1": "22mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.163.2072",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 2204573637,
                "created_at": "2015-09-23T11:23:46+01:00",
                "updated_at": "2017-11-20T11:32:08+00:00"
            },
            {
                "id": 6331857861,
                "title": "22mm / Extra Long",
                "option1": "22mm",
                "option2": "Extra Long",
                "option3": null,
                "sku": "BR.163.2073",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "345.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 4,
                "product_id": 2204573637,
                "created_at": "2015-09-23T11:23:46+01:00",
                "updated_at": "2017-11-12T10:12:19+00:00"
            }
        ],
        "images": [
            {
                "id": 4215246597,
                "created_at": "2015-09-23T11:26:56+01:00",
                "position": 1,
                "updated_at": "2015-09-23T11:26:56+01:00",
                "product_id": 2204573637,
                "variant_ids": [],
                "src": alligatorStrapBlack,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 4215247045,
                "created_at": "2015-09-23T11:26:58+01:00",
                "position": 2,
                "updated_at": "2015-09-23T11:26:58+01:00",
                "product_id": 2204573637,
                "variant_ids": [],
                "src": alligatorStrapBlack,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long",
                    "Extra Long"
                ]
            }
        ]
    },
    {
        "id": 2204557509,
        "title": "Canvas Strap - Green",
        "handle": "canvas-strap-green",
        "body_html": "<meta charset=\"utf-8\">\n<p>Green canvas strap with leather lining and embossed Bremont logo.</p>\n<p>Lightly cushioned with a tapered profile.</p>\n<meta charset=\"utf-8\">\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-11-22T15:13:54+00:00",
        "created_at": "2015-09-23T11:18:24+01:00",
        "updated_at": "2017-11-23T12:16:34+00:00",
        "vendor": "Bremont",
        "product_type": "Canvas Straps",
        "tags": [
            "canvas",
            "canvas-straps",
            "for-the-adventurer",
            "green",
            "length-regular",
            "over-150",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 6331780421,
                "title": "22mm / Regular",
                "option1": "22mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.163.2040",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "155.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2204557509,
                "created_at": "2015-09-23T11:18:24+01:00",
                "updated_at": "2017-11-12T23:29:18+00:00"
            }
        ],
        "images": [
            {
                "id": 4215212101,
                "created_at": "2015-09-23T11:21:48+01:00",
                "position": 1,
                "updated_at": "2015-09-23T11:21:48+01:00",
                "product_id": 2204557509,
                "variant_ids": [],
                "src": canvasStrapGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 4215212293,
                "created_at": "2015-09-23T11:21:50+01:00",
                "position": 2,
                "updated_at": "2015-09-23T11:21:50+01:00",
                "product_id": 2204557509,
                "variant_ids": [],
                "src": canvasStrapGreen,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular"
                ]
            }
        ]
    },
    {
        "id": 2204482245,
        "title": "Leather Strap - EP120 Black/White",
        "handle": "leather-strap-ep120-black",
        "body_html": "<meta charset=\"utf-8\">\n<p>Black calf leather EP120 strap with white stitching and embossed Bremont logo.</p>\n<p><span>Lightly cushioned with a tapered profile.</span></p>\n<meta charset=\"utf-8\">\n<p><span>Designed for double pin buckles only.</span></p>\n<meta charset=\"utf-8\">\n<p><span><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></span></p>",
        "published_at": "2017-11-22T15:13:54+00:00",
        "created_at": "2015-09-23T10:48:43+01:00",
        "updated_at": "2017-11-23T13:30:39+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Straps",
        "tags": [
            "black",
            "for-the-gentleman",
            "leather",
            "leather-straps",
            "length-regular",
            "over-150",
            "size-22mm",
            "white"
        ],
        "variants": [
            {
                "id": 6331362501,
                "title": "22mm / Regular / Black",
                "option1": "22mm",
                "option2": "Regular",
                "option3": "Black",
                "sku": "BR.162.1002",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2204482245,
                "created_at": "2015-09-23T10:48:43+01:00",
                "updated_at": "2017-11-20T15:14:39+00:00"
            }
        ],
        "images": [
            {
                "id": 4214962437,
                "created_at": "2015-09-23T10:48:59+01:00",
                "position": 1,
                "updated_at": "2015-09-23T10:48:59+01:00",
                "product_id": 2204482245,
                "variant_ids": [],
                "src": leatherStrapBlackWhite,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 4214963269,
                "created_at": "2015-09-23T10:49:01+01:00",
                "position": 2,
                "updated_at": "2015-09-23T10:49:01+01:00",
                "product_id": 2204482245,
                "variant_ids": [],
                "src": leatherStrapBlackWhite,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Black"
                ]
            }
        ]
    },
    {
        "id": 2204815621,
        "title": "MB Barrel Cufflinks - Bronze",
        "handle": "mb-barrel-cufflinks-bronze",
        "body_html": "<p>Bremont’s circular MB Barrel Cufflinks feature the knurled barrel design as seen on the popular MB and U-2 wrist watches.</p>\n<p>The MB Barrel Cufflinks are made from a strong combination of aluminium and stainless steel whilst the new T-bar fitting ensures ultimate functionality.</p>",
        "published_at": "2017-11-21T17:51:50+00:00",
        "created_at": "2015-09-23T12:30:12+01:00",
        "updated_at": "2017-12-07T00:52:15+00:00",
        "vendor": "Bremont",
        "product_type": "Cufflinks",
        "tags": [
            "100-150",
            "cufflinks",
            "for-the-gentleman",
            "for-the-motorist",
            "stainless-steel"
        ],
        "variants": [
            {
                "id": 6332873349,
                "title": "Bronze",
                "option1": "Bronze",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5002",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "125.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2204815621,
                "created_at": "2015-09-23T12:30:12+01:00",
                "updated_at": "2017-12-07T00:52:15+00:00"
            }
        ],
        "images": [
            {
                "id": 6226034373,
                "created_at": "2015-11-27T12:52:39+00:00",
                "position": 1,
                "updated_at": "2015-11-27T12:52:39+00:00",
                "product_id": 2204815621,
                "variant_ids": [],
                "src": mbBarrelBronze,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 6226035077,
                "created_at": "2015-11-27T12:52:41+00:00",
                "position": 2,
                "updated_at": "2015-11-27T12:52:41+00:00",
                "product_id": 2204815621,
                "variant_ids": [],
                "src": mbBarrelBronze,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Color",
                "position": 1,
                "values": [
                    "Bronze"
                ]
            }
        ]
    },
    {
        "id": 2380208965,
        "title": "Pin Buckle - Titanium",
        "handle": "pin-buckle-titanium",
        "body_html": "The titanium pin buckle features a highly polished bevel and signature Bremont logo engraving.",
        "published_at": "2017-11-20T13:26:55+00:00",
        "created_at": "2015-10-08T17:36:08+01:00",
        "updated_at": "2017-12-11T11:04:00+00:00",
        "vendor": "Bremont",
        "product_type": "Clasps and Buckles",
        "tags": [
            "50-100",
            "buckles",
            "size-20mm",
            "titanium"
        ],
        "variants": [
            {
                "id": 6885352901,
                "title": "20mm / Titanium",
                "option1": "20mm",
                "option2": "Titanium",
                "option3": null,
                "sku": "BR.062.1009",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "80.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2380208965,
                "created_at": "2015-10-08T17:36:08+01:00",
                "updated_at": "2017-12-11T11:04:00+00:00"
            }
        ],
        "images": [
            {
                "id": 4633635205,
                "created_at": "2015-10-08T17:36:20+01:00",
                "position": 1,
                "updated_at": "2015-10-08T17:36:20+01:00",
                "product_id": 2380208965,
                "variant_ids": [],
                "src": pinBuckleTitanium,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "20mm"
                ]
            },
            {
                "name": "Color",
                "position": 2,
                "values": [
                    "Titanium"
                ]
            }
        ]
    },
    {
        "id": 2380164805,
        "title": "Pin Buckle - Stainless Steel",
        "handle": "pin-buckle-stainless-steel",
        "body_html": "<meta charset=\"utf-8\"><span>The brushed stainless steel pin buckle features a highly polished bevel and signature Bremont logo engraving.</span>",
        "published_at": "2017-11-20T13:26:50+00:00",
        "created_at": "2015-10-08T17:31:21+01:00",
        "updated_at": "2017-12-05T19:33:45+00:00",
        "vendor": "Bremont",
        "product_type": "Clasps and Buckles",
        "tags": [
            "50-100",
            "buckles",
            "size-18mm",
            "size-20mm",
            "stainless-steel"
        ],
        "variants": [
            {
                "id": 6885192261,
                "title": "20mm / Steel",
                "option1": "20mm",
                "option2": "Steel",
                "option3": null,
                "sku": "BR.062.1002",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "80.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2380164805,
                "created_at": "2015-10-08T17:31:21+01:00",
                "updated_at": "2017-12-05T19:33:45+00:00"
            },
            {
                "id": 6885260933,
                "title": "18mm / Steel",
                "option1": "18mm",
                "option2": "Steel",
                "option3": null,
                "sku": "BR.062.1001",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "80.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 2380164805,
                "created_at": "2015-10-08T17:33:14+01:00",
                "updated_at": "2017-11-12T10:19:24+00:00"
            }
        ],
        "images": [
            {
                "id": 4633556037,
                "created_at": "2015-10-08T17:31:46+01:00",
                "position": 1,
                "updated_at": "2015-10-08T17:31:46+01:00",
                "product_id": 2380164805,
                "variant_ids": [],
                "src": pinBuckleSteel,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "20mm",
                    "18mm"
                ]
            },
            {
                "name": "Color",
                "position": 2,
                "values": [
                    "Steel"
                ]
            }
        ]
    },
    {
        "id": 2380215749,
        "title": "Pin Buckle - Polished Stainless Steel",
        "handle": "pin-buckle-polished-stainless-steel",
        "body_html": "<meta charset=\"utf-8\"><span>The polished stainless steel pin buckle features a highly polished finish and signature Bremont logo engraving.</span>",
        "published_at": "2017-11-20T13:26:45+00:00",
        "created_at": "2015-10-08T17:36:43+01:00",
        "updated_at": "2017-12-05T03:40:15+00:00",
        "vendor": "Bremont",
        "product_type": "Clasps and Buckles",
        "tags": [
            "50-100",
            "buckles",
            "size-14mm",
            "size-18mm",
            "size-20mm",
            "stainless-steel"
        ],
        "variants": [
            {
                "id": 6885374085,
                "title": "20mm / Steel",
                "option1": "20mm",
                "option2": "Steel",
                "option3": null,
                "sku": "BR.200.2200",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "80.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2380215749,
                "created_at": "2015-10-08T17:36:43+01:00",
                "updated_at": "2017-11-23T17:02:40+00:00"
            },
            {
                "id": 37698828553,
                "title": "18mm / Steel",
                "option1": "18mm",
                "option2": "Steel",
                "option3": null,
                "sku": "BR.062.2001",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "80.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 2380215749,
                "created_at": "2017-06-12T13:14:44+01:00",
                "updated_at": "2017-12-05T03:40:15+00:00"
            },
            {
                "id": 37702296777,
                "title": "14mm / Steel",
                "option1": "14mm",
                "option2": "Steel",
                "option3": null,
                "sku": "BR.062.1021",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "65.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 2380215749,
                "created_at": "2017-06-12T13:49:04+01:00",
                "updated_at": "2017-11-15T08:56:15+00:00"
            }
        ],
        "images": [
            {
                "id": 4633647429,
                "created_at": "2015-10-08T17:36:54+01:00",
                "position": 1,
                "updated_at": "2015-10-08T17:36:54+01:00",
                "product_id": 2380215749,
                "variant_ids": [],
                "src": pinBuckleSteelPolished,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "20mm",
                    "18mm",
                    "14mm"
                ]
            },
            {
                "name": "Color",
                "position": 2,
                "values": [
                    "Steel"
                ]
            }
        ]
    },
    {
        "id": 2380196933,
        "title": "Pin Buckle - DLC",
        "handle": "pin-buckle-dlc",
        "body_html": "<meta charset=\"utf-8\"><span>The DLC coated stainless steel pin buckle features a highly polished bevel and signature Bremont logo engraving.</span>",
        "published_at": "2017-11-20T13:25:30+00:00",
        "created_at": "2015-10-08T17:35:03+01:00",
        "updated_at": "2017-11-23T15:19:27+00:00",
        "vendor": "Bremont",
        "product_type": "Clasps and Buckles",
        "tags": [
            "50-100",
            "buckles",
            "dlc",
            "size-20mm"
        ],
        "variants": [
            {
                "id": 6885316229,
                "title": "20mm / Black",
                "option1": "20mm",
                "option2": "Black",
                "option3": null,
                "sku": "BR.062.1003",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "80.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2380196933,
                "created_at": "2015-10-08T17:35:03+01:00",
                "updated_at": "2017-11-20T12:38:11+00:00"
            }
        ],
        "images": [
            {
                "id": 4633617477,
                "created_at": "2015-10-08T17:35:16+01:00",
                "position": 1,
                "updated_at": "2015-10-08T17:35:16+01:00",
                "product_id": 2380196933,
                "variant_ids": [],
                "src": pinBuckleDlc,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "20mm"
                ]
            },
            {
                "name": "Color",
                "position": 2,
                "values": [
                    "Black"
                ]
            }
        ]
    },
    {
        "id": 2541811013,
        "title": "NATO Strap - Khaki",
        "handle": "nato-strap-khaki",
        "body_html": "<p>Khaki NATO strap with Velcro fastening, featuring a hand-stitched Bremont logo.</p>\n<p>Handmade in England and designed for ultimate functionality, the Bremont NATO strap features a simple fail-safe method to keep the watch secure in the event a spring bar breaks or detaches.</p>\n<p>The strap is made from durable nylon and features leather keepers with a <span>stainless steel</span> loop.</p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-11-16T12:13:16+00:00",
        "created_at": "2015-10-22T21:58:43+01:00",
        "updated_at": "2017-11-30T16:37:50+00:00",
        "vendor": "Bremont",
        "product_type": "NATO Straps",
        "tags": [
            "50-100",
            "khaki",
            "length-regular",
            "nato-straps",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 7401420677,
                "title": "22mm / Regular / Khaki",
                "option1": "22mm",
                "option2": "Regular",
                "option3": "Khaki",
                "sku": "BR.163.2265",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2541811013,
                "created_at": "2015-10-22T21:58:43+01:00",
                "updated_at": "2017-11-30T16:37:50+00:00"
            }
        ],
        "images": [
            {
                "id": 5116652357,
                "created_at": "2015-10-26T11:04:03+00:00",
                "position": 1,
                "updated_at": "2015-10-26T11:04:03+00:00",
                "product_id": 2541811013,
                "variant_ids": [],
                "src": natoStrapKhaki,
                "width": 1025,
                "height": 1025
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Khaki"
                ]
            }
        ]
    },
    {
        "id": 2541805061,
        "title": "NATO Strap - Black/Red",
        "handle": "nato-strap-black-red",
        "body_html": "<p>Black NATO strap with red stitching and Velcro fastening, featuring a hand-stitched Bremont logo.</p>\n<p>Handmade in England and designed for ultimate functionality, the Bremont NATO strap features a simple fail-safe method to keep the watch secure in the event a spring bar breaks or detaches.</p>\n<p>The strap is made from durable nylon and features leather keepers with a <span>stainless steel</span> loop.</p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-11-16T12:13:15+00:00",
        "created_at": "2015-10-22T21:57:59+01:00",
        "updated_at": "2017-12-08T16:04:40+00:00",
        "vendor": "Bremont",
        "product_type": "NATO Straps",
        "tags": [
            "50-100",
            "black",
            "length-regular",
            "nato-straps",
            "red",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 7401397445,
                "title": "22mm / Regular / Black",
                "option1": "22mm",
                "option2": "Regular",
                "option3": "Black",
                "sku": "BR.163.2263",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2541805061,
                "created_at": "2015-10-22T21:57:59+01:00",
                "updated_at": "2017-12-08T16:04:40+00:00"
            }
        ],
        "images": [
            {
                "id": 5116637957,
                "created_at": "2015-10-26T11:03:30+00:00",
                "position": 1,
                "updated_at": "2015-10-26T11:03:30+00:00",
                "product_id": 2541805061,
                "variant_ids": [],
                "src": natoStrapBlackRed,
                "width": 1025,
                "height": 1025
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Black"
                ]
            }
        ]
    },
    {
        "id": 2536711301,
        "title": "NATO Strap - Black/White",
        "handle": "nato-strap-black-white",
        "body_html": "<p>Black NATO strap with white stitching and Velcro fastening, featuring a hand-stitched Bremont logo.</p>\n<p>Handmade in England and designed for ultimate functionality, the Bremont NATO strap features a simple fail-safe method to keep the watch secure in the event a spring bar breaks or detaches.</p>\n<p>The strap is made from durable nylon and features leather keepers with a <span>stainless steel</span> loop.</p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-11-16T12:13:15+00:00",
        "created_at": "2015-10-22T12:20:16+01:00",
        "updated_at": "2017-11-30T10:18:10+00:00",
        "vendor": "Bremont",
        "product_type": "NATO Straps",
        "tags": [
            "50-100",
            "black",
            "length-regular",
            "nato-straps",
            "size-22mm",
            "white"
        ],
        "variants": [
            {
                "id": 7386683717,
                "title": "22mm / Regular / Black",
                "option1": "22mm",
                "option2": "Regular",
                "option3": "Black",
                "sku": "BR.163.2260",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 2536711301,
                "created_at": "2015-10-22T12:20:16+01:00",
                "updated_at": "2017-11-30T10:18:10+00:00"
            }
        ],
        "images": [
            {
                "id": 5116645765,
                "created_at": "2015-10-26T11:03:48+00:00",
                "position": 1,
                "updated_at": "2015-10-26T11:03:48+00:00",
                "product_id": 2536711301,
                "variant_ids": [],
                "src": natoStrapBlackWhite,
                "width": 1025,
                "height": 1025
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Black"
                ]
            }
        ]
    },
    {
        "id": 8504510729,
        "title": "Hip Flask",
        "handle": "hip-flask",
        "body_html": "<p class=\"p1\">Bremont’s 4oz stainless steel Hip Flask is hand covered using fine English leather to promise a luxurious feel. The hunter green, kidney shaped flask features signature embossing and a hinged screw top, making it practical for all outdoor pursuits and adventures. Bremont’s Hip Flask measures a width of 9.8cm by 9.4cm height, sizes may vary marginally. Please note that our flask is suitable for cold drinks only.</p>",
        "published_at": "2017-11-16T11:01:34+00:00",
        "created_at": "2016-11-24T11:29:48+00:00",
        "updated_at": "2017-12-07T19:26:45+00:00",
        "vendor": "Bremont",
        "product_type": "Metal Goods",
        "tags": [
            "50-100",
            "for-the-adventurer",
            "for-the-gentleman",
            "for-the-lady",
            "Hip Flasks",
            "leather",
            "metal-goods",
            "stainless-steel"
        ],
        "variants": [
            {
                "id": 28236543689,
                "title": "Default Title",
                "option1": "Default Title",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5025",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "95.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 8504510729,
                "created_at": "2016-11-24T11:32:32+00:00",
                "updated_at": "2017-12-07T19:26:45+00:00"
            }
        ],
        "images": [
            {
                "id": 17411673865,
                "created_at": "2016-11-24T11:31:49+00:00",
                "position": 1,
                "updated_at": "2016-11-24T11:32:03+00:00",
                "product_id": 8504510729,
                "variant_ids": [],
                "src": hipFlask,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411673225,
                "created_at": "2016-11-24T11:31:46+00:00",
                "position": 2,
                "updated_at": "2016-11-24T11:32:03+00:00",
                "product_id": 8504510729,
                "variant_ids": [],
                "src": hipFlask,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411673481,
                "created_at": "2016-11-24T11:31:47+00:00",
                "position": 3,
                "updated_at": "2016-11-24T11:32:03+00:00",
                "product_id": 8504510729,
                "variant_ids": [],
                "src": hipFlask,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411672585,
                "created_at": "2016-11-24T11:31:42+00:00",
                "position": 4,
                "updated_at": "2016-11-24T11:32:03+00:00",
                "product_id": 8504510729,
                "variant_ids": [],
                "src": hipFlask,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411672969,
                "created_at": "2016-11-24T11:31:44+00:00",
                "position": 5,
                "updated_at": "2016-11-24T11:32:03+00:00",
                "product_id": 8504510729,
                "variant_ids": [],
                "src": hipFlask,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Title",
                "position": 1,
                "values": [
                    "Default Title"
                ]
            }
        ]
    },
    {
        "id": 10359775945,
        "title": "Bremont Invictus Games UK Team Supporters Bracelet",
        "handle": "bremont-invictus-games-supporters-bracelet",
        "body_html": "<h3 class=\"p1\"><strong>Limited production collector's edition.</strong></h3>\n<p><span>We are immensely proud to be an official supporter of the UK Team for the <a href=\"https://invictusgamesfoundation.org/\">Invictus Games</a>. We marked the partnership by creating bespoke Bremont bracelets for each of the 90-strong team and have now created a collector’s edition.</span></p>\n<p>Bremont supports the UK Team via Help for Heroes and will donate 100% of profits of the sale price of each Bracelet to Help for Heroes Trading Limited which Gift Aids all its taxable profits to Help for Heroes (Registered Charity Number 1120920). We expect to donate at least £15,000.</p>\n<p><span>Bremont are fortunate to have had the opportunity to work extensively with the military, designing and manufacturing watches for squadrons all over the world. The opportunity to honour those who have served our country in this way is something we are very proud to do.</span></p>\n<p class=\"p1\"><em><span class=\"s1\"><img src=\"//cdn.shopify.com/s/files/1/0985/9080/files/help-for-heroes-logo_compact.png?v=1504279428\" alt=\"\"></span></em></p>\n<meta charset=\"utf-8\">\n<p class=\"p1\"><span class=\"s1\">Bracelet measurements: <em>Medium: 18.5cm</em></span></p>\n<p class=\"p1\"><span class=\"s1\">Leather band and polished stainless steel disc</span></p>",
        "published_at": "2017-09-04T14:32:45+01:00",
        "created_at": "2017-08-30T13:39:56+01:00",
        "updated_at": "2017-12-11T17:45:45+00:00",
        "vendor": "Bremont",
        "product_type": "Invictus Games UK Team Supporters Bracelet",
        "tags": [
            "for-the-adventurer",
            "for-the-motorist",
            "invictus",
            "invictus-games-uk-team-supporters-bracelet",
            "leather",
            "size-large-20-5cm",
            "size-medium-18-5cm",
            "under-50"
        ],
        "variants": [
            {
                "id": 44410822281,
                "title": "Medium (18.5cm)",
                "option1": "Medium (18.5cm)",
                "option2": null,
                "option3": null,
                "sku": "BR.600.2090",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "34.99",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 10359775945,
                "created_at": "2017-08-30T13:39:56+01:00",
                "updated_at": "2017-12-08T08:57:25+00:00"
            },
            {
                "id": 1019271544859,
                "title": "Large (20.5cm)",
                "option1": "Large (20.5cm)",
                "option2": null,
                "option3": null,
                "sku": "BR.600.2191",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "34.99",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 10359775945,
                "created_at": "2017-09-19T11:07:29+01:00",
                "updated_at": "2017-12-11T17:45:45+00:00"
            }
        ],
        "images": [
            {
                "id": 23701366217,
                "created_at": "2017-08-30T13:39:58+01:00",
                "position": 1,
                "updated_at": "2017-09-08T11:49:36+01:00",
                "product_id": 10359775945,
                "variant_ids": [],
                "src": bremontInvictusBracelet,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 285869015067,
                "created_at": "2017-09-08T11:49:32+01:00",
                "position": 2,
                "updated_at": "2017-09-08T11:49:36+01:00",
                "product_id": 10359775945,
                "variant_ids": [],
                "src": bremontInvictusBracelet,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 228658216987,
                "created_at": "2017-09-01T16:30:27+01:00",
                "position": 3,
                "updated_at": "2017-09-08T11:49:36+01:00",
                "product_id": 10359775945,
                "variant_ids": [],
                "src": bremontInvictusBracelet,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 228658151451,
                "created_at": "2017-09-01T16:30:25+01:00",
                "position": 4,
                "updated_at": "2017-09-08T11:49:36+01:00",
                "product_id": 10359775945,
                "variant_ids": [],
                "src": bremontInvictusBracelet,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "Medium (18.5cm)",
                    "Large (20.5cm)"
                ]
            }
        ]
    },
    {
        "id": 10353382025,
        "title": "NATO Strap - Grey Canvas",
        "handle": "nato-strap-grey-canvas",
        "body_html": "<p>Grey Canvas NATO strap.</p>\n<p>A modern variation of the military staple 'G10' NATO strap but with a vintage look. Designed for ultimate functionality with a simple fail-safe method to keep the watch secure in the event a spring bar breaks or detaches. </p>\n<p>Should you require a pin buckle for your NATO strap, you can <a href=\"https://shop.bremont.com/collections/watch-straps/buckles\">purchase this here</a>.</p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-08-29T15:40:40+01:00",
        "created_at": "2017-08-29T12:47:12+01:00",
        "updated_at": "2017-12-13T11:13:50+00:00",
        "vendor": "Bremont",
        "product_type": "NATO Straps",
        "tags": [
            "canvas",
            "for-the-adventurer",
            "grey",
            "length-long",
            "length-regular",
            "nato-straps",
            "over-150",
            "size-20mm",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 44319065865,
                "title": "22mm / Long",
                "option1": "22mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.163.2083",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": false,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 10353382025,
                "created_at": "2017-08-29T13:01:43+01:00",
                "updated_at": "2017-12-13T11:13:50+00:00"
            },
            {
                "id": 44318957321,
                "title": "20mm / Regular",
                "option1": "20mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.163.2068",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 10353382025,
                "created_at": "2017-08-29T12:59:29+01:00",
                "updated_at": "2017-12-06T13:18:18+00:00"
            },
            {
                "id": 44319057865,
                "title": "20mm / Long",
                "option1": "20mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.163.2079",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 10353382025,
                "created_at": "2017-08-29T13:01:26+01:00",
                "updated_at": "2017-11-17T16:25:24+00:00"
            }
        ],
        "images": [
            {
                "id": 1474896232475,
                "created_at": "2017-11-28T12:44:20+00:00",
                "position": 1,
                "updated_at": "2017-11-28T12:44:20+00:00",
                "product_id": 10353382025,
                "variant_ids": [],
                "src": natoStrapGreyCanvas,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm",
                    "20mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Long",
                    "Regular"
                ]
            }
        ]
    },
    {
        "id": 10353476297,
        "title": "NATO Strap - Stone Canvas",
        "handle": "nato-strap-stone-canvas",
        "body_html": "<p>Stone Canvas NATO strap.</p>\n<p>A modern variation of the military staple 'G10' NATO strap but with a vintage look. Designed for ultimate functionality with a simple fail-safe method to keep the watch secure in the event a spring bar breaks or detaches. </p>\n<p><span>Should you require a pin buckle for your NATO strap, you can </span><a href=\"https://shop.bremont.com/collections/watch-straps/buckles\">purchase this here</a><span>.</span></p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-08-29T15:40:35+01:00",
        "created_at": "2017-08-29T13:05:37+01:00",
        "updated_at": "2017-12-06T13:20:20+00:00",
        "vendor": "Bremont",
        "product_type": "NATO Straps",
        "tags": [
            "brown",
            "canvas",
            "for-the-adventurer",
            "length-long",
            "length-regular",
            "nato-straps",
            "over-150",
            "size-20mm",
            "size-22mm",
            "stone"
        ],
        "variants": [
            {
                "id": 44319205961,
                "title": "22mm / Regular",
                "option1": "22mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.163.2080",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 10353476297,
                "created_at": "2017-08-29T13:05:37+01:00",
                "updated_at": "2017-11-29T18:45:25+00:00"
            },
            {
                "id": 44319206025,
                "title": "22mm / Long",
                "option1": "22mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.163.2082",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": false,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 10353476297,
                "created_at": "2017-08-29T13:05:37+01:00",
                "updated_at": "2017-11-17T16:19:44+00:00"
            },
            {
                "id": 44319205833,
                "title": "20mm / Regular",
                "option1": "20mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.163.2067",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 10353476297,
                "created_at": "2017-08-29T13:05:37+01:00",
                "updated_at": "2017-12-06T13:20:20+00:00"
            },
            {
                "id": 44319205897,
                "title": "20mm / Long",
                "option1": "20mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.163.2078",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "75.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 4,
                "product_id": 10353476297,
                "created_at": "2017-08-29T13:05:37+01:00",
                "updated_at": "2017-11-17T16:22:17+00:00"
            }
        ],
        "images": [
            {
                "id": 1474906390555,
                "created_at": "2017-11-28T12:47:12+00:00",
                "position": 1,
                "updated_at": "2017-11-28T12:47:12+00:00",
                "product_id": 10353476297,
                "variant_ids": [],
                "src": natoStrapStoneCanvas,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm",
                    "20mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9767015305,
        "title": "Nubuck Ladies Strap - Black",
        "handle": "nubuck-ladies-strap-black",
        "body_html": "<meta charset=\"utf-8\">\n<p>Black buffalo nubuck leather strap with black stitching and embossed Bremont logo.</p>\n<p><span>Lightly cushioned with a tapered profile.</span></p>\n<meta charset=\"utf-8\">\n<p><span><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></span></p>",
        "published_at": "2017-07-05T14:00:03+01:00",
        "created_at": "2017-06-15T11:04:26+01:00",
        "updated_at": "2017-11-23T12:19:30+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Straps",
        "tags": [
            "100-150",
            "black",
            "leather-straps",
            "length-long",
            "length-regular",
            "length-short",
            "size-16mm"
        ],
        "variants": [
            {
                "id": 37950572937,
                "title": "16mm / Regular",
                "option1": "16mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.164.2257",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9767015305,
                "created_at": "2017-06-15T11:04:27+01:00",
                "updated_at": "2017-11-17T16:29:33+00:00"
            },
            {
                "id": 37950573129,
                "title": "16mm / Short",
                "option1": "16mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.164.2267",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9767015305,
                "created_at": "2017-06-15T11:04:27+01:00",
                "updated_at": "2017-11-17T16:30:15+00:00"
            },
            {
                "id": 37950573257,
                "title": "16mm / Long",
                "option1": "16mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.164.2268",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9767015305,
                "created_at": "2017-06-15T11:04:27+01:00",
                "updated_at": "2017-11-17T16:30:52+00:00"
            }
        ],
        "images": [
            {
                "id": 21435684937,
                "created_at": "2017-06-15T11:04:51+01:00",
                "position": 1,
                "updated_at": "2017-06-15T11:04:51+01:00",
                "product_id": 9767015305,
                "variant_ids": [],
                "src": nubuckLadiesStrapBlack,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21435703113,
                "created_at": "2017-06-15T11:05:53+01:00",
                "position": 2,
                "updated_at": "2017-06-15T11:05:53+01:00",
                "product_id": 9767015305,
                "variant_ids": [],
                "src": nubuckLadiesStrapBlack,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "16mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9766973321,
        "title": "Lizard Ladies Strap - White",
        "handle": "lizard-ladies-strap-white",
        "body_html": "<meta charset=\"utf-8\">\n<p>White genuine lizard leather strap with white stitching and embossed Bremont logo.</p>\n<p>Lightly cushioned with a taper profile.</p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-07-05T13:59:54+01:00",
        "created_at": "2017-06-15T10:52:09+01:00",
        "updated_at": "2017-11-23T12:23:23+00:00",
        "vendor": "Bremont",
        "product_type": "Alligator Straps",
        "tags": [
            "100-150",
            "alligator-straps",
            "for-the-lady",
            "leather",
            "length-long",
            "length-regular",
            "length-short",
            "lizard",
            "size-16mm",
            "white"
        ],
        "variants": [
            {
                "id": 37949350793,
                "title": "16mm / Regular",
                "option1": "16mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.164.2255",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9766973321,
                "created_at": "2017-06-15T10:52:09+01:00",
                "updated_at": "2017-11-15T09:51:18+00:00"
            },
            {
                "id": 37949350921,
                "title": "16mm / Short",
                "option1": "16mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.164.2263",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9766973321,
                "created_at": "2017-06-15T10:52:09+01:00",
                "updated_at": "2017-11-20T09:15:01+00:00"
            },
            {
                "id": 37949351049,
                "title": "16mm / Long",
                "option1": "16mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.164.2264",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9766973321,
                "created_at": "2017-06-15T10:52:09+01:00",
                "updated_at": "2017-11-20T09:15:23+00:00"
            }
        ],
        "images": [
            {
                "id": 21435467657,
                "created_at": "2017-06-15T10:52:36+01:00",
                "position": 1,
                "updated_at": "2017-06-15T10:52:36+01:00",
                "product_id": 9766973321,
                "variant_ids": [],
                "src": lizardLadiesStrapWhite,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "16mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9767038217,
        "title": "Leather Ladies Strap - Tan",
        "handle": "leather-ladies-strap-tan",
        "body_html": "<meta charset=\"utf-8\">\n<p>Tan calf leather strap with off white stitching and embossed Bremont logo.</p>\n<p><span>Lightly cushioned with a tapered profile.</span></p>\n<meta charset=\"utf-8\">\n<p><span><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></span></p>",
        "published_at": "2017-07-05T13:59:50+01:00",
        "created_at": "2017-06-15T11:11:53+01:00",
        "updated_at": "2017-11-23T12:32:10+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Straps",
        "tags": [
            "100-150",
            "for-the-lady",
            "leather-straps",
            "length-long",
            "length-regular",
            "length-short",
            "size-16mm",
            "tan"
        ],
        "variants": [
            {
                "id": 37951273737,
                "title": "16mm / Regular",
                "option1": "16mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.164.2256",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9767038217,
                "created_at": "2017-06-15T11:11:53+01:00",
                "updated_at": "2017-11-17T16:26:54+00:00"
            },
            {
                "id": 37951273801,
                "title": "16mm / Short",
                "option1": "16mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.164.2265",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9767038217,
                "created_at": "2017-06-15T11:11:53+01:00",
                "updated_at": "2017-11-17T16:28:16+00:00"
            },
            {
                "id": 37951273865,
                "title": "16mm / Long",
                "option1": "16mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.164.2266",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "129.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9767038217,
                "created_at": "2017-06-15T11:11:54+01:00",
                "updated_at": "2017-11-17T16:27:35+00:00"
            }
        ],
        "images": [
            {
                "id": 21435821513,
                "created_at": "2017-06-15T11:12:23+01:00",
                "position": 1,
                "updated_at": "2017-06-15T11:12:23+01:00",
                "product_id": 9767038217,
                "variant_ids": [],
                "src": leatherLadiesStrapTan,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21435823881,
                "created_at": "2017-06-15T11:12:31+01:00",
                "position": 2,
                "updated_at": "2017-06-15T11:12:31+01:00",
                "product_id": 9767038217,
                "variant_ids": [],
                "src": leatherLadiesStrapTan,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "16mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9766931401,
        "title": "Crocodile Ladies Strap - Dark Red",
        "handle": "crocodile-ladies-strap-dark-red",
        "body_html": "<meta charset=\"utf-8\">\n<p>Dark Red genuine crocodile leather strap with red stitching and embossed Bremont logo.</p>\n<p>Lightly cushioned with a taper profile.</p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-07-05T13:59:40+01:00",
        "created_at": "2017-06-15T10:44:11+01:00",
        "updated_at": "2017-11-23T12:23:10+00:00",
        "vendor": "Bremont",
        "product_type": "Alligator Straps",
        "tags": [
            "alligator-straps",
            "crocodile",
            "crocodile-straps",
            "dark-red",
            "for-the-lady",
            "leather",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "red",
            "size-16mm"
        ],
        "variants": [
            {
                "id": 37948447433,
                "title": "16mm / Regular",
                "option1": "16mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.164.2253",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9766931401,
                "created_at": "2017-06-15T10:44:11+01:00",
                "updated_at": "2017-11-15T09:51:03+00:00"
            },
            {
                "id": 37948447497,
                "title": "16mm / Short",
                "option1": "16mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.164.2259",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9766931401,
                "created_at": "2017-06-15T10:44:11+01:00",
                "updated_at": "2017-11-20T09:16:48+00:00"
            },
            {
                "id": 37948447561,
                "title": "16mm / Long",
                "option1": "16mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.164.2260",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9766931401,
                "created_at": "2017-06-15T10:44:11+01:00",
                "updated_at": "2017-11-20T09:23:38+00:00"
            }
        ],
        "images": [
            {
                "id": 21435244297,
                "created_at": "2017-06-15T10:44:20+01:00",
                "position": 1,
                "updated_at": "2017-06-15T10:44:20+01:00",
                "product_id": 9766931401,
                "variant_ids": [],
                "src": crocodileLadiesStrapDarkRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21435245449,
                "created_at": "2017-06-15T10:44:26+01:00",
                "position": 2,
                "updated_at": "2017-06-15T10:44:26+01:00",
                "product_id": 9766931401,
                "variant_ids": [],
                "src": crocodileLadiesStrapDarkRed,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "16mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9766912073,
        "title": "Alligator Ladies Strap - Dark Blue",
        "handle": "alligator-ladies-strap-dark-blue",
        "body_html": "<meta charset=\"utf-8\">\n<p>Dark blue genuine alligator leather strap with blue stitching and embossed Bremont logo.</p>\n<p>Lightly cushioned with a taper profile.</p>\n<meta charset=\"utf-8\">\n<p><span>Available to customers in the United Kingdom only.</span></p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-07-05T13:59:28+01:00",
        "created_at": "2017-06-15T10:41:02+01:00",
        "updated_at": "2017-11-23T12:22:58+00:00",
        "vendor": "Bremont",
        "product_type": "Alligator Straps",
        "tags": [
            "alligator",
            "alligator-straps",
            "blue",
            "dark-blue",
            "for-the-lady",
            "leather",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-16mm"
        ],
        "variants": [
            {
                "id": 37948141833,
                "title": "16mm / Regular",
                "option1": "16mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.164.2254",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9766912073,
                "created_at": "2017-06-15T10:41:02+01:00",
                "updated_at": "2017-11-20T09:24:44+00:00"
            },
            {
                "id": 37948141897,
                "title": "16mm / Short",
                "option1": "16mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.164.2261",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9766912073,
                "created_at": "2017-06-15T10:41:02+01:00",
                "updated_at": "2017-11-15T09:50:55+00:00"
            },
            {
                "id": 37948142025,
                "title": "16mm / Long",
                "option1": "16mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.164.2262",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": false,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9766912073,
                "created_at": "2017-06-15T10:41:02+01:00",
                "updated_at": "2017-11-20T09:27:19+00:00"
            }
        ],
        "images": [
            {
                "id": 21435156809,
                "created_at": "2017-06-15T10:41:13+01:00",
                "position": 1,
                "updated_at": "2017-06-15T10:41:13+01:00",
                "product_id": 9766912073,
                "variant_ids": [],
                "src": alligatorLadiesStrapDarkBlue,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21435158537,
                "created_at": "2017-06-15T10:41:19+01:00",
                "position": 2,
                "updated_at": "2017-06-15T10:41:19+01:00",
                "product_id": 9766912073,
                "variant_ids": [],
                "src": alligatorLadiesStrapDarkBlue,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "16mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9766808137,
        "title": "Alligator Ladies Strap - Black",
        "handle": "alligator-ladies-strap-black",
        "body_html": "<meta charset=\"utf-8\">\n<p>Black genuine alligator leather strap with black stitching and embossed Bremont logo.</p>\n<p>Lightly cushioned with a taper profile.</p>\n<meta charset=\"utf-8\">\n<p><span>Available to customers in the United Kingdom only.</span></p>\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-07-05T13:59:23+01:00",
        "created_at": "2017-06-15T10:16:18+01:00",
        "updated_at": "2017-11-23T12:22:51+00:00",
        "vendor": "Bremont",
        "product_type": "Alligator Straps",
        "tags": [
            "alligator",
            "alligator-straps",
            "black",
            "for-the-lady",
            "leather",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-16mm"
        ],
        "variants": [
            {
                "id": 37945312713,
                "title": "16mm / Regular",
                "option1": "16mm",
                "option2": "Regular",
                "option3": null,
                "sku": "BR.164.2258",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9766808137,
                "created_at": "2017-06-15T10:16:18+01:00",
                "updated_at": "2017-11-20T09:29:12+00:00"
            },
            {
                "id": 37945312777,
                "title": "16mm / Short",
                "option1": "16mm",
                "option2": "Short",
                "option3": null,
                "sku": "BR.164.2269",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9766808137,
                "created_at": "2017-06-15T10:16:18+01:00",
                "updated_at": "2017-11-20T09:29:55+00:00"
            },
            {
                "id": 37945312841,
                "title": "16mm / Long",
                "option1": "16mm",
                "option2": "Long",
                "option3": null,
                "sku": "BR.164.2270",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "249.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9766808137,
                "created_at": "2017-06-15T10:16:18+01:00",
                "updated_at": "2017-11-20T09:30:33+00:00"
            }
        ],
        "images": [
            {
                "id": 21434630601,
                "created_at": "2017-06-15T10:16:57+01:00",
                "position": 1,
                "updated_at": "2017-06-15T10:16:57+01:00",
                "product_id": 9766808137,
                "variant_ids": [],
                "src": alligatorLadiesStrapBlack,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21434632521,
                "created_at": "2017-06-15T10:17:05+01:00",
                "position": 2,
                "updated_at": "2017-06-15T10:17:05+01:00",
                "product_id": 9766808137,
                "variant_ids": [],
                "src": alligatorLadiesStrapBlack,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "16mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            }
        ]
    },
    {
        "id": 9737767113,
        "title": "Leather Strap - Black/Red - Norton V4",
        "handle": "leather-strap-norton-black-red",
        "body_html": "<meta charset=\"utf-8\">\n<p>Black calf leather racing strap with red stitching and embossed Bremont logo.</p>\n<p><span>Lightly cushioned with a tapered profile.</span></p>\n<meta charset=\"utf-8\">\n<p><span><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></span></p>",
        "published_at": "2017-07-05T13:58:24+01:00",
        "created_at": "2017-06-12T15:27:41+01:00",
        "updated_at": "2017-11-23T13:28:22+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Straps",
        "tags": [
            "blue",
            "for-the-gentleman",
            "leather-straps",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-22mm"
        ],
        "variants": [
            {
                "id": 37710165001,
                "title": "22mm / Regular / Black",
                "option1": "22mm",
                "option2": "Regular",
                "option3": "Black",
                "sku": "BR.164.2208",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9737767113,
                "created_at": "2017-06-12T15:27:41+01:00",
                "updated_at": "2017-11-19T19:41:05+00:00"
            },
            {
                "id": 37710165065,
                "title": "22mm / Short / Black",
                "option1": "22mm",
                "option2": "Short",
                "option3": "Black",
                "sku": "BR.164.2207",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9737767113,
                "created_at": "2017-06-12T15:27:41+01:00",
                "updated_at": "2017-11-15T08:56:55+00:00"
            },
            {
                "id": 37710165129,
                "title": "22mm / Long / Black",
                "option1": "22mm",
                "option2": "Long",
                "option3": "Black",
                "sku": "BR.164.2209",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9737767113,
                "created_at": "2017-06-12T15:27:41+01:00",
                "updated_at": "2017-11-15T08:56:55+00:00"
            }
        ],
        "images": [
            {
                "id": 21351176137,
                "created_at": "2017-06-12T15:28:22+01:00",
                "position": 1,
                "updated_at": "2017-06-12T15:28:22+01:00",
                "product_id": 9737767113,
                "variant_ids": [],
                "src": leatherStrapBlackRedNortonV4,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21351178441,
                "created_at": "2017-06-12T15:28:30+01:00",
                "position": 2,
                "updated_at": "2017-06-12T15:28:30+01:00",
                "product_id": 9737767113,
                "variant_ids": [],
                "src": leatherStrapBlackRedNortonV4,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "22mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Black"
                ]
            }
        ]
    },
    {
        "id": 9737621065,
        "title": "Vintage Leather Strap - Dark Brown - Full Stitch",
        "handle": "full-stitch-vintage-leather-strap-dark-brown",
        "body_html": "<meta charset=\"utf-8\">\n<p>Dark brown vintage leather strap with full stitch and embossed Bremont logo.</p>\n<p>Suede finish with a taper profile.</p>\n<meta charset=\"utf-8\">\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-07-05T13:57:43+01:00",
        "created_at": "2017-06-12T15:19:48+01:00",
        "updated_at": "2017-12-10T09:31:10+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Straps",
        "tags": [
            "brown",
            "for-the-gentleman",
            "leather-straps",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-20mm"
        ],
        "variants": [
            {
                "id": 37709540361,
                "title": "20mm / Regular / Brown",
                "option1": "20mm",
                "option2": "Regular",
                "option3": "Brown",
                "sku": "BR.163.2065",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9737621065,
                "created_at": "2017-06-12T15:19:48+01:00",
                "updated_at": "2017-12-10T09:31:10+00:00"
            },
            {
                "id": 37709540553,
                "title": "20mm / Short / Brown",
                "option1": "20mm",
                "option2": "Short",
                "option3": "Brown",
                "sku": "BR.163.2064",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9737621065,
                "created_at": "2017-06-12T15:19:48+01:00",
                "updated_at": "2017-11-15T08:56:53+00:00"
            },
            {
                "id": 37709540617,
                "title": "20mm / Long / Brown",
                "option1": "20mm",
                "option2": "Long",
                "option3": "Brown",
                "sku": "BR.163.2066",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9737621065,
                "created_at": "2017-06-12T15:19:48+01:00",
                "updated_at": "2017-11-15T08:56:53+00:00"
            }
        ],
        "images": [
            {
                "id": 21351007817,
                "created_at": "2017-06-12T15:20:08+01:00",
                "position": 1,
                "updated_at": "2017-06-12T15:20:08+01:00",
                "product_id": 9737621065,
                "variant_ids": [],
                "src": vintageLeatherStrapDarkBrownFullStitch,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21351010441,
                "created_at": "2017-06-12T15:20:14+01:00",
                "position": 2,
                "updated_at": "2017-06-12T15:20:14+01:00",
                "product_id": 9737621065,
                "variant_ids": [],
                "src": vintageLeatherStrapDarkBrownFullStitch,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "20mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Brown"
                ]
            }
        ]
    },
    {
        "id": 9737490953,
        "title": "Vintage Leather Strap - Dark Brown - Side Stitch",
        "handle": "side-stitch-vintage-leather-strap-dark-brown",
        "body_html": "<meta charset=\"utf-8\">\n<p>Dark brown vintage leather strap with side stitch and embossed Bremont logo.</p>\n<p>Suede finish with a taper profile.</p>\n<meta charset=\"utf-8\">\n<p><a href=\"http://www.bremont.com/images/files/Bremont-Strap-Sizing-Guide.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">View our Strap Sizing Guide here</a></p>",
        "published_at": "2017-07-05T13:56:22+01:00",
        "created_at": "2017-06-12T15:13:36+01:00",
        "updated_at": "2017-12-05T03:40:15+00:00",
        "vendor": "Bremont",
        "product_type": "Leather Straps",
        "tags": [
            "brown",
            "for-the-gentleman",
            "leather-straps",
            "length-long",
            "length-regular",
            "length-short",
            "over-150",
            "size-20mm"
        ],
        "variants": [
            {
                "id": 37708970953,
                "title": "20mm / Regular / Brown",
                "option1": "20mm",
                "option2": "Regular",
                "option3": "Brown",
                "sku": "BR.163.2058",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 9737490953,
                "created_at": "2017-06-12T15:13:36+01:00",
                "updated_at": "2017-12-05T03:40:15+00:00"
            },
            {
                "id": 37708971017,
                "title": "20mm / Short / Brown",
                "option1": "20mm",
                "option2": "Short",
                "option3": "Brown",
                "sku": "BR.163.2057",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 2,
                "product_id": 9737490953,
                "created_at": "2017-06-12T15:13:36+01:00",
                "updated_at": "2017-11-15T08:56:52+00:00"
            },
            {
                "id": 37708971081,
                "title": "20mm / Long / Brown",
                "option1": "20mm",
                "option2": "Long",
                "option3": "Brown",
                "sku": "BR.163.2059",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "175.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 3,
                "product_id": 9737490953,
                "created_at": "2017-06-12T15:13:36+01:00",
                "updated_at": "2017-11-15T08:56:53+00:00"
            }
        ],
        "images": [
            {
                "id": 21350889609,
                "created_at": "2017-06-12T15:15:04+01:00",
                "position": 1,
                "updated_at": "2017-06-12T15:15:04+01:00",
                "product_id": 9737490953,
                "variant_ids": [],
                "src": vintageLeatherStrapDarkBrownSideStitch,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 21350892553,
                "created_at": "2017-06-12T15:15:15+01:00",
                "position": 2,
                "updated_at": "2017-06-12T15:15:15+01:00",
                "product_id": 9737490953,
                "variant_ids": [],
                "src": vintageLeatherStrapDarkBrownSideStitch,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Size",
                "position": 1,
                "values": [
                    "20mm"
                ]
            },
            {
                "name": "Length",
                "position": 2,
                "values": [
                    "Regular",
                    "Short",
                    "Long"
                ]
            },
            {
                "name": "Color",
                "position": 3,
                "values": [
                    "Brown"
                ]
            }
        ]
    },
    {
        "id": 8504488265,
        "title": "Pocket Square - Red",
        "handle": "pocket-square-by-turnbull-asser-red",
        "body_html": "<meta charset=\"utf-8\"><span>Bremont’s Pocket Square by Turnbull &amp; Asser subtly features our signature circular propeller logo to create a timeless polka-dot print. The finely patterned square is framed by a plain hem finish and can be teamed with Bremont’s Tie to perfect a polished look. Made in England, Bremont’s Pocket Square by Turnbull &amp; Asser is woven from 100% English silk and approximately measures 45cm by 45cm square, sizes mary vary marginally.</span>",
        "published_at": "2016-11-24T11:08:00+00:00",
        "created_at": "2016-11-24T11:23:22+00:00",
        "updated_at": "2017-12-10T18:04:25+00:00",
        "vendor": "Bremont",
        "product_type": "Pocket Squares",
        "tags": [
            "50-100",
            "for-the-gentleman",
            "for-the-motorist",
            "pocket-squares",
            "silk"
        ],
        "variants": [
            {
                "id": 28236337289,
                "title": "Default Title",
                "option1": "Default Title",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5053",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "55.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 8504488265,
                "created_at": "2016-11-24T11:23:22+00:00",
                "updated_at": "2017-12-10T18:04:25+00:00"
            }
        ],
        "images": [
            {
                "id": 17411591881,
                "created_at": "2016-11-24T11:24:28+00:00",
                "position": 1,
                "updated_at": "2016-11-24T11:24:34+00:00",
                "product_id": 8504488265,
                "variant_ids": [],
                "src": pocketSquareRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411588553,
                "created_at": "2016-11-24T11:24:00+00:00",
                "position": 2,
                "updated_at": "2016-11-24T11:24:34+00:00",
                "product_id": 8504488265,
                "variant_ids": [],
                "src": pocketSquareRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411590537,
                "created_at": "2016-11-24T11:24:15+00:00",
                "position": 3,
                "updated_at": "2016-11-24T11:24:34+00:00",
                "product_id": 8504488265,
                "variant_ids": [],
                "src": pocketSquareRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411589065,
                "created_at": "2016-11-24T11:24:04+00:00",
                "position": 4,
                "updated_at": "2016-11-24T11:24:34+00:00",
                "product_id": 8504488265,
                "variant_ids": [],
                "src": pocketSquareRed,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Title",
                "position": 1,
                "values": [
                    "Default Title"
                ]
            }
        ]
    },
    {
        "id": 8504479689,
        "title": "Pocket Square - Green",
        "handle": "pocket-square-by-turnbull-asser-green",
        "body_html": "<p class=\"p1\">Bremont’s Pocket Square by Turnbull &amp; Asser subtly features our signature circular propeller logo to create a timeless polka-dot print. The finely patterned square is framed by a plain hem finish and can be teamed with Bremont’s Tie to perfect a polished look. Made in England, Bremont’s Pocket Square by Turnbull &amp; Asser is woven from 100% English silk and approximately measures 45cm by 45cm square, sizes mary vary marginally.</p>",
        "published_at": "2016-11-24T11:08:00+00:00",
        "created_at": "2016-11-24T11:18:36+00:00",
        "updated_at": "2017-11-25T06:01:38+00:00",
        "vendor": "Bremont",
        "product_type": "Pocket Squares",
        "tags": [
            "50-100",
            "for-the-gentleman",
            "for-the-motorist",
            "pocket-squares",
            "silk"
        ],
        "variants": [
            {
                "id": 28236282057,
                "title": "Default Title",
                "option1": "Default Title",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5052",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "55.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 8504479689,
                "created_at": "2016-11-24T11:18:36+00:00",
                "updated_at": "2017-11-20T10:16:56+00:00"
            }
        ],
        "images": [
            {
                "id": 17411567305,
                "created_at": "2016-11-24T11:20:24+00:00",
                "position": 1,
                "updated_at": "2016-11-24T11:21:10+00:00",
                "product_id": 8504479689,
                "variant_ids": [],
                "src": pocketSquareGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411568265,
                "created_at": "2016-11-24T11:20:37+00:00",
                "position": 2,
                "updated_at": "2016-11-24T11:21:10+00:00",
                "product_id": 8504479689,
                "variant_ids": [],
                "src": pocketSquareGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411569289,
                "created_at": "2016-11-24T11:20:41+00:00",
                "position": 3,
                "updated_at": "2016-11-24T11:21:10+00:00",
                "product_id": 8504479689,
                "variant_ids": [],
                "src": pocketSquareGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411569929,
                "created_at": "2016-11-24T11:20:47+00:00",
                "position": 4,
                "updated_at": "2016-11-24T11:21:10+00:00",
                "product_id": 8504479689,
                "variant_ids": [],
                "src": pocketSquareGreen,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Title",
                "position": 1,
                "values": [
                    "Default Title"
                ]
            }
        ]
    },
    {
        "id": 8504473417,
        "title": "Tie - Green",
        "handle": "tie-by-turnbull-asser-green",
        "body_html": "<p class=\"p1\">Bremont’s Tie by Turnbull &amp; Asser subtly features our signature circular propeller logo to create a timeless polka-dot print. The finely patterned tie is woven from 100% English silk and can be teamed with Bremont’s Pocket Square to perfect a polished look. Made in England, Bremont’s Tie by Turnbull &amp; Asser approximately measures a width of 8cm, sizes may vary marginally.</p>",
        "published_at": "2016-11-24T11:08:00+00:00",
        "created_at": "2016-11-24T11:13:29+00:00",
        "updated_at": "2017-12-14T17:51:20+00:00",
        "vendor": "Bremont",
        "product_type": "Ties",
        "tags": [
            "50-100",
            "for-the-gentleman",
            "for-the-motorist",
            "silk",
            "tie",
            "ties"
        ],
        "variants": [
            {
                "id": 28236223433,
                "title": "Default Title",
                "option1": "Default Title",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5050",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "95.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 8504473417,
                "created_at": "2016-11-24T11:13:29+00:00",
                "updated_at": "2017-12-14T17:51:20+00:00"
            }
        ],
        "images": [
            {
                "id": 17411539209,
                "created_at": "2016-11-24T11:13:52+00:00",
                "position": 1,
                "updated_at": "2016-11-24T11:14:32+00:00",
                "product_id": 8504473417,
                "variant_ids": [],
                "src": tieGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411540745,
                "created_at": "2016-11-24T11:14:14+00:00",
                "position": 2,
                "updated_at": "2016-11-24T11:14:32+00:00",
                "product_id": 8504473417,
                "variant_ids": [],
                "src": tieGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411542153,
                "created_at": "2016-11-24T11:14:27+00:00",
                "position": 3,
                "updated_at": "2016-11-24T11:14:32+00:00",
                "product_id": 8504473417,
                "variant_ids": [],
                "src": tieGreen,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411541449,
                "created_at": "2016-11-24T11:14:20+00:00",
                "position": 4,
                "updated_at": "2016-11-24T11:14:32+00:00",
                "product_id": 8504473417,
                "variant_ids": [],
                "src": tieGreen,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Title",
                "position": 1,
                "values": [
                    "Default Title"
                ]
            }
        ]
    },
    {
        "id": 8504442825,
        "title": "Tie - Red",
        "handle": "tie-by-turnbull-asser-red",
        "body_html": "<p class=\"p1\">Bremont’s Tie by Turnbull &amp; Asser subtly features our signature circular propeller logo to create a timeless polka-dot print. The finely patterned tie is woven from 100% English silk and can be teamed with Bremont’s Pocket Square to perfect a polished look. Made in England, Bremont’s Tie by Turnbull &amp; Asser approximately measures a width of 8cm, sizes may vary marginally.</p>",
        "published_at": "2016-11-24T11:08:00+00:00",
        "created_at": "2016-11-24T10:53:30+00:00",
        "updated_at": "2017-12-09T18:20:25+00:00",
        "vendor": "Bremont",
        "product_type": "Ties",
        "tags": [
            "50-100",
            "for-the-gentleman",
            "for-the-motorist",
            "silk",
            "tie",
            "ties"
        ],
        "variants": [
            {
                "id": 28236015689,
                "title": "Default Title",
                "option1": "Default Title",
                "option2": null,
                "option3": null,
                "sku": "BR.600.5051",
                "requires_shipping": true,
                "taxable": true,
                "featured_image": null,
                "available": true,
                "price": "95.00",
                "grams": 200,
                "compare_at_price": null,
                "position": 1,
                "product_id": 8504442825,
                "created_at": "2016-11-24T10:54:07+00:00",
                "updated_at": "2017-12-09T18:20:25+00:00"
            }
        ],
        "images": [
            {
                "id": 17411502345,
                "created_at": "2016-11-24T11:04:04+00:00",
                "position": 1,
                "updated_at": "2016-11-24T11:04:16+00:00",
                "product_id": 8504442825,
                "variant_ids": [],
                "src": tieRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411499913,
                "created_at": "2016-11-24T11:03:28+00:00",
                "position": 2,
                "updated_at": "2016-11-24T11:04:16+00:00",
                "product_id": 8504442825,
                "variant_ids": [],
                "src": tieRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411500297,
                "created_at": "2016-11-24T11:03:33+00:00",
                "position": 3,
                "updated_at": "2016-11-24T11:04:16+00:00",
                "product_id": 8504442825,
                "variant_ids": [],
                "src": tieRed,
                "width": 1024,
                "height": 1024
            },
            {
                "id": 17411512073,
                "created_at": "2016-11-24T11:07:06+00:00",
                "position": 4,
                "updated_at": "2016-11-24T11:07:06+00:00",
                "product_id": 8504442825,
                "variant_ids": [],
                "src": tieRed,
                "width": 1024,
                "height": 1024
            }
        ],
        "options": [
            {
                "name": "Title",
                "position": 1,
                "values": [
                    "Default Title"
                ]
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/reducers/bremont/data.js